type Bridge = {
  onTokensRefreshed?: (accessToken: string, refreshToken: string) => void;
  onSessionInvalidated?: () => void;
};

let bridge: Bridge = {};

export function setAuthSessionBridge(next: Bridge): void {
  bridge = next;
}

export function clearAuthSessionBridge(): void {
  bridge = {};
}

export function notifyTokensRefreshed(accessToken: string, refreshToken: string): void {
  bridge.onTokensRefreshed?.(accessToken, refreshToken);
}

export function notifySessionInvalidated(): void {
  bridge.onSessionInvalidated?.();
}
